"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var ownKeys = function (o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rechner = exports.isSteuerklasse = exports.anzahlSteuerklassen = exports.isBeziehung = exports.anzahlBeziehungen = exports.TabelleGeschlechter = exports.isGeschlecht = exports.anzahlGeschlechter = exports.errorMsgSteuerrelevanterBetrag = exports.errorMsgErwerb = exports.errorMsgDivisor = exports.errorMsgZinssatz = void 0;
const Schenkungssteuer = __importStar(require("./schenkungssteuer"));
const Vervielfaeltiger = __importStar(require("./vervielfaeltiger"));
/*
————————————————————————————————————————————————————————————————————————————————
Exportierte Konstanten, Typen und Arrays
————————————————————————————————————————————————————————————————————————————————
*/
// Fehlermeldungen
exports.errorMsgZinssatz = 'Ungültiger oder unerlaubter Zinssatz';
exports.errorMsgDivisor = 'Ungültiger interner Wert für Divisor';
exports.errorMsgErwerb = 'Ungültiger Erwerb (negativ)';
exports.errorMsgSteuerrelevanterBetrag = 'Ungültiger steuerrelevanter Betrag (negativ)';
// ****************************************
// Bekannte Geschlechter
// ****************************************
const arrayGeschlecht = ['Mann', 'Frau'];
exports.anzahlGeschlechter = arrayGeschlecht.length;
// User-defined type guard, siehe https://www.typescriptlang.org/docs/handbook/advanced-types.html#user-defined-type-guards
const isGeschlecht = param => arrayGeschlecht.includes(param);
exports.isGeschlecht = isGeschlecht;
exports.TabelleGeschlechter = [{
  key: 'Frau',
  sortNr: 0,
  label: 'weiblich'
}, {
  key: 'Mann',
  sortNr: 1,
  label: 'männlich'
}];
// ****************************************
// Definierte Beziehungen
// ****************************************
const arrayBeziehung = ['Ehepartner', 'Kinder', 'Enkel', 'Geschwister', 'NichtenNeffen', 'Lebensgefährte'];
exports.anzahlBeziehungen = arrayBeziehung.length;
// User-defined type guard, siehe https://www.typescriptlang.org/docs/handbook/advanced-types.html#user-defined-type-guards
const isBeziehung = param => arrayBeziehung.includes(param);
exports.isBeziehung = isBeziehung;
// ****************************************
// Steuerklassen gemäß Schenkungs- und Erbschaftssteuergesetz
// ****************************************
const arraySteuerklasse = ['I', 'II', 'III'];
exports.anzahlSteuerklassen = arraySteuerklasse.length;
// User-defined type guard, siehe https://www.typescriptlang.org/docs/handbook/advanced-types.html#user-defined-type-guards
const isSteuerklasse = param => arraySteuerklasse.includes(param);
exports.isSteuerklasse = isSteuerklasse;
/*
————————————————————————————————————————————————————————————————————————————————
Rechner-Klasse
————————————————————————————————————————————————————————————————————————————————
*/
// Klassen
let Rechner = /*#__PURE__*/(() => {
  class Rechner {
    // Unter- und Obergrenzen für Parameter (auch im UI)
    static minAlter = 0;
    static maxAlter = 122;
    // Wert von 0% ist mathematisch nicht sinnvoll
    static minZinssatz = 0.05;
    // BewG §16: maximal Gesamtwert/18,6 für Jahreswert, entsprechend 5,3763…%
    static maxZinssatz = 5.37;
    // ****************************************
    // Informationsfunktionen
    // ****************************************
    // Liste aller Geschlechter
    listeGeschlechterInfo() {
      return exports.TabelleGeschlechter.map(element => {
        return {
          geschlecht: element.key,
          sortNr: element.sortNr,
          label: element.label
        };
      });
    }
    // Liste aller Beziehungen
    listeBeziehungenInfo() {
      return Schenkungssteuer.TabelleSteuerdaten.map(element => {
        return {
          beziehung: element.key,
          sortNr: element.sortNr,
          label: element.label
        };
      });
    }
    // Liste aller Steuerklassen
    listeSteuerklassen() {
      return [...arraySteuerklasse];
    }
    // Für Berechnungen verwendetes Jahr
    ermittleVerwendetesJahr() {
      return Vervielfaeltiger.ermittleVerwendetesJahr();
    }
    // Zusatzdaten BMF zum für Berechnungen verwendeten Jahr
    ermittleVerwendetesJahrZusatzdaten(inputJahr) {
      return Vervielfaeltiger.ermittleVerwendetesJahrZusatzdaten(inputJahr);
    }
    // ****************************************
    // Hauptfunktionen
    // ****************************************
    // Berechne maximalen Schenkungsbetrag, der ohne Steuern möglich ist
    // (unter Berücksichtigung des Freibetrags)
    berechneMaximaleSchenkung(beziehung, geschlecht, alter, zinssatzErtrag, rundung = 0, jahr = Vervielfaeltiger.ermittleVerwendetesJahr()) {
      // Prüfung Inputwerte (nur für Parameter, bei denen das nicht durch die aufgerufenen Funktionen passiert)
      if (zinssatzErtrag < Rechner.minZinssatz || zinssatzErtrag > Rechner.maxZinssatz) {
        throw Error(exports.errorMsgZinssatz);
      }
      rundung = rundung < 0 ? 0 : rundung;
      rundung = rundung > 4 ? 4 : rundung;
      // Ermittlung benötigter Rechengrößen
      const freibetrag = Schenkungssteuer.ermittleFreibetrag(beziehung);
      const vervielfaeltiger = Vervielfaeltiger.ermittleVervielfaeltiger(jahr, geschlecht, alter);
      // Berechnung des Divisors
      const divisor = 1 - zinssatzErtrag / 100 * vervielfaeltiger;
      // Der folgende Fall sollte bei den üblichen Werten (Parameter ‹zinssatzErtrag› ≤ 5,376%
      // laut BewG §16 und Parameter ‹vervielfältiger› typischerweise ≤ 18.46x selbst für
      // 0-jährige Frauen) nie vorkommen, zur Sicherheit (und Vermeidung mathematischer Probleme
      // im nächsten Schritt) wird er hier aber trotzdem explizit abgefangen.
      // Es ist in der zugehörigen Test-Suite jedoch kein eigener Test dafür vorgesehen, weil
      // die nachfolgende Bedingung eben nicht wahr werden und der Fehler nicht explizit
      // ausgelöst werden kann
      if (divisor <= 0) {
        throw Error(exports.errorMsgDivisor);
      }
      // Berechnung des maximal zulässigen Volumens
      let volumen = freibetrag / divisor;
      // Analog zum Erwerbsgesetz (immer Abrundung auf volle Hundert Euro) wird auch das Volumen gerundet,
      // zur Sicherheit ebenfalls immer nach unten. Der Parameter ‹rundung› gibt dabei die entsprechende
      // Zehnerpotenz an (Default 2 entspricht Rundung auf volle 100 EUR, 3 entspricht vollen 1.000 EUR
      // und 4 entspricht vollen 10.000 EUR). Höhere Werte ergeben keinen Sinn und werden ignoriert.
      volumen = Math.trunc(volumen / 10 ** rundung) * 10 ** rundung;
      return volumen;
    }
    // Berechne zu versteuernden Erwerb bei Schenkung ohne Nießbrauch
    // Hinweis: Freibetrag ist im Ergebnis bereits abgezogen!
    berechneErwerbOhneNiessbrauch(erwerbBetrag, beziehung) {
      // Prüfung Inputwerte (nur für Parameter, bei denen das nicht durch die aufgerufenen Funktionen passiert)
      if (erwerbBetrag < 0) {
        throw Error(exports.errorMsgErwerb);
      }
      // Ermittlung benötigter Rechengrößen
      const freibetrag = Schenkungssteuer.ermittleFreibetrag(beziehung);
      // Berechnung des steuerrelevanten Betrags, Werte werden dabei
      // nach unten durch 0 begrenzt (keine negativen Resultate)
      let betragSteuerrelevant = Math.max(erwerbBetrag - freibetrag, 0);
      // Abrundung auf volle Hundert Euro
      betragSteuerrelevant = Math.trunc(betragSteuerrelevant / 100) * 100;
      return betragSteuerrelevant;
    }
    // Berechne zu versteuernden Erwerb bei Schenkung mit Nießbrauch
    // Hinweis: Freibetrag ist im Ergebnis bereits abgezogen!
    berechneErwerbMitNiessbrauch(erwerbBetrag, beziehung, geschlecht, alter, zinssatzErtrag, jahr = Vervielfaeltiger.ermittleVerwendetesJahr()) {
      // Prüfung Inputwerte (nur für Parameter, bei denen das nicht durch die aufgerufenen Funktionen passiert)
      if (erwerbBetrag < 0) {
        throw Error(exports.errorMsgErwerb);
      }
      if (zinssatzErtrag < Rechner.minZinssatz || zinssatzErtrag > Rechner.maxZinssatz) {
        throw Error(exports.errorMsgZinssatz);
      }
      // Ermittlung benötigter Rechengrößen
      const freibetrag = Schenkungssteuer.ermittleFreibetrag(beziehung);
      const vervielfaeltiger = Vervielfaeltiger.ermittleVervielfaeltiger(jahr, geschlecht, alter);
      // Berechnung des Kapitalwerts des Nießbrauchs, Werte kleiner 0 werden dabei nach unten
      // begrenzt, auch wenn das an dieser Stelle noch nicht unbedingt nötig wäre (da dieser
      // Fall am Ende noch mal abgefangen wird)
      const ertrag = erwerbBetrag * (zinssatzErtrag / 100) * vervielfaeltiger;
      const kapitalWert = Math.max(erwerbBetrag - ertrag, 0);
      // Berechnung des steuerrelevanten Betrags, Werte werden dabei
      // nach unten durch 0 begrenzt (keine negativen Resultate)
      let betragSteuerrelevant = Math.max(kapitalWert - freibetrag, 0);
      // Gemäß Erwerbsgesetz erfolgt immer eine Abrundung auf volle Hundert Euro
      betragSteuerrelevant = Math.trunc(betragSteuerrelevant / 100) * 100;
      return betragSteuerrelevant;
    }
    // Berechne Schenkungssteuer auf einen zu versteuernden Erwerb
    // Hinweise: – Es erfolgt keine Berücksichtigung eines Freibetrags, sondern es wird davon
    //             ausgegangen, dass dieser bereits abgezogen wurde, so wie es bereits in den
    //             Funktionen "berechneErwerbOhneNiessbrauch" und "berechneErwerbMitNiessbrauch"
    //             der Fall ist.
    //           – Es gibt keine zeitliche Abhängigkeit, die Steuerlogik ist fest definiert. Sollte
    //             sich die (als relativ statisch angenommene) Steuergesetzgebung später doch ändern,
    //             muss eine entsprechende Anpassung der Lookups oder gar der Berechnungsmethodik
    //             vorgenommen werden.
    berechneSteuerAufErwerb(steuerrelevanterBetrag, beziehung) {
      // Prüfung Inputwerte (nur für Parameter, bei denen das nicht durch die aufgerufenen Funktionen passiert)
      if (steuerrelevanterBetrag < 0) {
        throw Error(exports.errorMsgSteuerrelevanterBetrag);
      }
      // Ermittlung aller benötigter Rechengrößen
      const steuerklasse = Schenkungssteuer.ermittleSteuerklasse(beziehung);
      const steuersatz = Schenkungssteuer.ermittleSteuersatz(steuerrelevanterBetrag, steuerklasse);
      const steuersatzundWertgrenzeVorhergehend = Schenkungssteuer.ermittleSteuersatzUndWertgrenzeVorhergehend(steuerrelevanterBetrag, steuerklasse);
      // Berechnung der Schenkungssteuer mit tatsächlichem Steuersatz sowie der Steuer auf die
      // letztvorhergehende Wertgrenze
      const wertgrenze = steuersatzundWertgrenzeVorhergehend.wertgrenze;
      const steuerZahlungVoll = steuerrelevanterBetrag * steuersatz / 100;
      const steuerZahlungVorherigeGrenze = wertgrenze * steuersatzundWertgrenzeVorhergehend.steuersatz / 100;
      // Berechnung der Differenz auf die Steuern
      const steuerDifferenz = steuerZahlungVoll - steuerZahlungVorherigeGrenze;
      // Bruchteilsermittlung (1/2 oder 3/4) anhand des Steuersatzes
      const bruchteil = steuersatz <= 30 ? 0.5 : 0.75;
      // Berechnung des die Wertgrenze übersteigenden Betrags
      const limitHaertefall = bruchteil * (steuerrelevanterBetrag - wertgrenze);
      // Anwendung der Limitierung
      // Sollte die Steuerdifferenz größer sein als das berechnete Limit, wird nur dieses
      // Limit angesetzt. Andernfalls wird die Differenz voll veranschlagt (so dass man mit
      // der nachstehenden Rechnung wieder beim vollen Steuersatz landet, d.h. es gilt dann
      // ‹steuerEffektiv› = ‹steuerZahlungVoll›)
      let steuerZahlungEffektiv = steuerZahlungVorherigeGrenze + Math.min(steuerDifferenz, limitHaertefall);
      // Rundung auf Cent-Beträge (zwei Nachkommastellen)
      steuerZahlungEffektiv = Math.trunc(steuerZahlungEffektiv * 100 + 0.5) / 100;
      return steuerZahlungEffektiv;
    }
  }
  return Rechner;
})();
exports.Rechner = Rechner;
